import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { CheckType } from '@app/shared/models/models';
import { CommessaService, ISearchEnteCommessaParams } from '@app/shared/services/commessa.service';
import { ISearchParteParams } from '@app/shared/services/parti.service';

@Component({
    selector: 'mdm-input-ente-commessa-select',
    templateUrl: './input-ente-commessa-select.component.html',
    styleUrl: './input-ente-commessa-select.component.scss',
    standalone: false
})
export class InputEnteCommessaSelectComponent {

  @Input() options: Array<IS1InputSelectItem>;
  @Input() label: string;
  @Input() control: UntypedFormControl;
  @Input() bindAllObject: boolean = true;
  @Input() readonly: boolean = false;
  @Input() type: CheckType;

  @Input() set anno(newValue: number[]) {
    this._anno = newValue;
    this.search();
  }

  @Output() onSelectClear = new EventEmitter();
  @Output() onSelectChange = new EventEmitter();

  _anno: number[];
  _ente: string;

  constructor(private commessaService: CommessaService) { }
  
  ngAfterViewInit(): void {
    this.search();
  }

  ngOnInit(): void {}
  
  cleared() {
    this.onSelectClear.emit();
  }

  changed(event) {
    this.onSelectChange.emit(event);
  }

  setEnteAndSearch(text?: string) {
    this._ente = text;
    this.search();
  }

  search() {

    if (this._ente?.length < 3 || this.type == null) {
      this.options = [];
      return;
    }

    const params: ISearchEnteCommessaParams = {
      paging: true,
      page: 1,
      rows: 30,
      ente: this._ente,
      anno: this._anno
    }

    this.commessaService.getEnti(params, this.type).subscribe(options => {

      this.options = options.map(option => {

        return {
          code: option.id,
          label: option.name
        } as IS1InputSelectItem

      })

    })

  }

}
